import { ChangeDetectorRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalLoaderService } from '@app-core/providers/global-loader.service';
import { PagedDataProvider } from '@shared/models/data-provider.model';
import { Field } from '@shared/models/field.model';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

export abstract class AbstractTableComponent<P extends PagedDataProvider<D>, D> implements OnInit, OnDestroy {
  @Input()
  public fields: Field[];

  public displayedColumns: string[];

  @Input()
  public provider: P;

  @Input()
  public responseKey: string;

  @Input()
  public heightGrow = true;

  @ViewChild(MatPaginator, { static: true })
  public paginator: MatPaginator;

  public dataSource: MatTableDataSource<D>;

  public resultsLength = 0;

  protected data$: Subscription;

  constructor(protected cd: ChangeDetectorRef,
              protected globalLoader: GlobalLoaderService) {
  }

  ngOnInit() {

    this.paginator.pageSize = this.provider.page.pageSize;
    this.provider.paginator = this.paginator;

    this.displayedColumns = this.fields.map(field => field.name);
    this.dataSource = this.provider.dataSource;

    this.prepareData();
    this.provider.reload();
  }

  ngOnDestroy() {
    if (this.data$) {
      this.data$.unsubscribe();
    }
    this.dataSource.disconnect();
  }

  public get isLoading(): Observable<number> {
    return this.globalLoader.loadingState$;
  }

  protected prepareData(): void {
    this.data$ = this.provider.refreshState
      .pipe(
        switchMap(() => this.paginator.page.pipe(startWith({}))),
        switchMap(() => {
          this.globalLoader.push();
          this.provider.page.currentIndex = this.paginator.pageIndex;

          return this.provider.loadData();
        }),
        map(data => {
          this.globalLoader.pop();
          this.resultsLength = (<any>data).meta.total;

          return data;
        }),
        catchError(() => {
          this.globalLoader.pop();
          return of([]);
        })
      )
      .subscribe(data => {
        this.dataSource.connect().next(data[this.responseKey]);
        this.cd.detectChanges();
      });
  }
}
